<template>
  <div >
    <nav-header></nav-header>
    <section class="container clear">
      <aside class="aside">
        <div class="avatar-area">
          <img class="avatar" :src="asideInfo.AccountLogo" alt="">
        </div>
        <div class="name-area">
          <div class="name">{{asideInfo.AccountName}}</div>
          <div class="child-name">{{asideInfo.AccountRoleName}}<i class="icon-auth" v-if="userInfo&&userInfo.IsAuthentication"></i></div>
        </div>
        <ul class="nav-menu">
          <li class="nav-item" v-for="nav in navList" :key="nav.id">
            <span class="nav-item-name" @click="collapse(nav.id)">{{nav.MenuLabel}}</span>
            <ul class="nav-children" :style="{'height':nav.open?nav.children.length*40+'px':'0px'}">
              <li :class="['nav-child',{'current':item.current}]" @click="jump(nav.id,index)" v-for="(item,index) in nav.children" :key="index">{{item.MenuLabel}}</li>
            </ul>
          </li>
        </ul>
      </aside>
      <div class="content-wrapper">
        <router-view></router-view>
      </div>
    </section>
    <page-footer></page-footer>
    <fixed-right></fixed-right>
  </div>
</template>

<script>
import navHeader from '@/components/navHeader.vue'
import footer from '@/components/footer.vue'
import FixedRight from '@/components/fixedRight.vue'
import {GetWebLeftData} from '@/scripts/api.js'
import {mapState} from 'vuex'
export default {
  name: 'companyCenter',
  components:{
    navHeader,
    'page-footer':footer,
    FixedRight
  },
  data(){
    return{
      asideInfo:{},
      navList:[]
    }
  },
  computed:{
    ...mapState({
      userInfo:state=>state.userInfo,
    }),
  },
  watch:{
    userInfo(value,old){
      if(value && (!old.LoginAccountId || value.LoginAccountId != old.LoginAccountId)){
        this.initAsideMenu();
      }
    },
    $route(to,from){
      if(this.navList){
        this.initMenu();
      }
    }
  },
  created(){
    if(this.userInfo){
      this.initAsideMenu();
    }
  },
  methods: {
    //获取侧边栏导航
    initAsideMenu(){
      GetWebLeftData({
        platform:'pcweb',
        accountId:this.userInfo.LoginAccountId,
        accountType:this.userInfo.LoginAccountType,
        menuCode:'userCenter'
      }).then(r=>{
        if(r.Result==1){
          this.asideInfo=r.Data;
          let list=r.Data.LeftMenuList || [];
          for (let i = 0; i < list.length; i++) {
            list[i]['open']=false;
            list[i]['id']=list[i].MenuCode;
            list[i]['children']=list[i].LeftMenuList;
            for (let j = 0; j < list[i].children.length; j++) {
              list[i].children[j]['current']=false;
              list[i].children[j]['isLink']=true;
              list[i].children[j]['url']=list[i].children[j].MenuUrl;
              var index=(list[i].children[j].url).indexOf('companyCenter.html#');
              if(index>-1){
                list[i].children[j].url=list[i].children[j].url.split('#')[1];
                list[i].children[j]['isLink']=false;
              }
              if((list[i].children[j].url).indexOf('/ApplyCompanyService/BusinessServices')>-1){
                //服务站信息
                list[i].children[j].url='/serviceSiteInfo';
                list[i].children[j]['isLink']=false;
              }
            }
          }
          this.navList=list;
          this.initMenu();
        }
      })
    },
    //左侧导航菜单展开
    collapse(id){
      this.navList.map((item,i)=>{
        if(item.id==id){
          item.open=!item.open;
          this.$set(this.navList,i,item);
        }else{
          item.open=false;
        }
      })
    },
    //跳转到子页面
    jump(id,index){
      let index1=0,index2=0;
      for(let i=0;i<this.navList.length;i++){
        for(let j=0;j<this.navList[i].children.length;j++){
          this.navList[i].children[j].current=false;
          if(this.navList[i].id==id && index==j){
            this.navList[i].children[j].current=true;
            index1=i;
            index2=j;
          }
        }
      }
      if(this.navList[index1].children[index2].isLink){
        window.location.href=this.navList[index1].children[index2].url;
      }else{
        this.$router.replace(this.navList[index1].children[index2].url);
      }
    },
    //左侧菜单当前状态
    initMenu(){
      var path=window.location.hash.substr(1);
      if(path=='/' || !path){
        return;
      }
      for(let i=0;i<this.navList.length;i++){
        this.navList[i].open=false;
        for(let j=0;j<this.navList[i].children.length;j++){
          this.navList[i].children[j].current=false;
          if(path===this.navList[i].children[j].url && !this.navList[i].children[j].isLink){
            this.navList[i].open=true;
            this.navList[i].children[j].current=true;
          }
          if(path=='/serviceCertificate'&& this.navList[i].children[j].MenuCode=='accountCenter_updateCompanyService'){
            //服务站编辑
            this.navList[i].open=true;
            this.navList[i].children[j].current=true;
          }
        }
      }
    }
  },
}
</script>

<style lang="scss">
@import '@/style/select.scss';
@import '@/style/pagination.scss';
@import '@/style/switch.scss';
@import '@/style/messagebox.scss';
@import '@/style/reset.scss';
.container{
  width: 1200px;
  margin: 0 auto;
  background-color: #fff;
  padding-top: 68px;
  overflow: hidden;
  position: relative;
  min-height: 1000px;
  .aside{
    position: absolute;
    left: 0;
    top: 68px;
    width: 190px;
    background-color: #f75959;
    // background:linear-gradient(90deg,#f15227 0%,#f75959 100%);
    color: #fff;
    padding-bottom: 99999px;
    margin-bottom: -99999px;
  }
  .avatar-area{
    overflow: hidden;
    width: 100px;
    height: 100px;
    margin: 30px auto;
    .avatar{
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 100px;
      background-color: #fff;
    }
  }
  .name-area{
    text-align: center;
    padding: 0 10px;
    .name{
      font-size: 20px;
      line-height: 1.5;
      margin-bottom: 10px;
    }
    .child-name{
      font-size: 12px;
      line-height: 1.5;
    }
    .icon-auth{
      width: 50px;
      height: 16px;
      display: inline-block;
      vertical-align: middle;
      margin-top: -3px;
      margin-left: 6px;
      background: url(../../assets/icon-auth.png) no-repeat center /contain;
    }
  }
  .nav-menu{
    width: 100%;
    margin-top: 50px;
    .nav-item{
      min-height: 72px;
    }
    .nav-item-name{
      display: block;
      font-size: 18px;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
      margin-bottom: 8px;
      user-select: none;
    }
    .nav-children{
      height: 0;
      overflow: hidden;
      transition:all 0.2s linear;
    }
    .nav-child{
      font-size: 16px;
      height: 32px;
      line-height: 32px;
      padding-left: 30px;
      padding-right: 40px;
      text-align: right;
      margin-bottom: 8px;
      cursor: pointer;
      user-select: none;
      transition: 0.1s all ease-in-out;
      &.current{
        padding-right: 37px;
        background-color: rgba(255,255,255,0.2);
      }
      &:hover{
        padding-right: 37px;
        background-color: rgba(255,255,255,0.2);
      }
    }
    
  }
}
//以下分页公用样式
  .content-wrapper{
    float: right;
    width: 1010px;
    background-color: #fff;
    padding-left: 20px;
    padding-top:20px;
    padding-bottom:40px;
    .paging-title{
      font-size:18px;
      color: #333;
      line-height: 30px;
      float: left;
    }
    .btn-default{
      float: right;
      width: 80px;
      height: 30px;
      line-height: 28px;
      text-align: center;
      font-size: 14px;
      border: 1px solid #f75959;
      color: #f75959;
      background-color: #fff;
      cursor:pointer;
      margin-left:10px;
      &:hover{
        background-color: #f75959;
        color:#fff;
      }
    }

  }

</style>